import { graphql } from '@/gql';

import '@/services/partners/fragments/partnerFieldConfigFragment';

graphql(`
  fragment PartnerFragment on PartnerType {
    id
    codeName
    name
    infoForOperator
    subsidyDescription
    hasActiveSubsidyRule
    partnerCallerCreatedAt
    timeZone
    isPharmacy
    isSpecialRequest
    preferredVendorRideTypes
    shouldDisplaySurge
    shouldDisplayPartnerCosts
    isAutoConfirmSurge
    subsidyLocations
    isApprovedAddressPartner
    isScheduledRideRestricted
    isSelfServeDashboard
    rideAllowance {
      tiers {
        name
        allowance
      }
    }
    callOptions {
      scheduledRideReminderMinutesAfterCreation
    }
    planData {
      durationSize
      durationUnit
      isAutoRenewal
      isEditableDates
      isStartDateEditable
      notificationDays
    }
    rideOptions {
      partnerRidePurposes
    }
    config {
      logoUrl
      collectCc
      shouldDisplaySurge
      shouldDisplayPartnerCosts
      allowWillCallRides
    }
    serviceCode
    fieldConfig {
      ...PartnerFieldConfigFragment
    }
  }
`);
